import { render, staticRenderFns } from "./Contrast.vue?vue&type=template&id=55809f56&scoped=true&"
import script from "./Contrast.vue?vue&type=script&lang=js&"
export * from "./Contrast.vue?vue&type=script&lang=js&"
import style0 from "./Contrast.vue?vue&type=style&index=0&id=55809f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55809f56",
  null
  
)

export default component.exports